import React, { Fragment } from "react";
import { Box, Grid, CircularProgress } from "@material-ui/core";

export default function PleaseWait({ hidingMessage, onHideMessage }) {
  const containerStyle = {
    transform: hidingMessage ? "translateY(40px)" : "translateY(0px)",
    opacity: hidingMessage ? 0 : 1,
  };
  const checkStyle = {
    transform: hidingMessage ? "translateY(30px)" : "translateY(0px)",
  };

  return (
    <Fragment>
      <Grid
        container
        display="flex"
        justifyContent={"center"}
        style={containerStyle}
        className={"transition-all"}
      >
        <Box
          position={"absolute"}
          height={"100%"}
          display="flex"
          alignItems="center"
          justifyContent={"center"}
          top={0}
          style={checkStyle}
          className={"transition-all"}
        >
          <CircularProgress color="primary" />
        </Box>
        <Box height={"300px"} />
      </Grid>
    </Fragment>
  );
}
